module.exports = __webpack_public_path__ + "img/id-card.7bfb954c.jpg";